<template>
  <div class="web-head row clearfix">
    <div class="col-lg-4">
      <router-link to="/index">
        <div style="  height: 45px ; display: flex;  align-items: center;justify-content: flex-start ">
          <img class="web-head-logo"
               style=" width:45px;height: 45px;margin: 0;margin-right: 10px "
               src="@/assets/images/logo.png">
          <span class="web-head-title" style="font-size:35px ; line-height: 45px; ">
						{{ title }}
					</span>
        </div>
      </router-link>
    </div>
    <div class="col-lg-8 menu-content">
      <router-link to="/index">首页</router-link>
<!--      <router-link to="/about">关于</router-link>-->
<!--      <router-link to="/experience">体验</router-link>-->
<!--      <router-link to="/cooperation">合作</router-link>-->
    </div>
  </div>
</template>

<script>
export default {
  name: 'myHeader',
  props: {
    title: {
      type: String,
      required: false,
      default: '卓讯互动'
    }
  },
  data() {
    return {
      localUrl: window.location.href,
      recordNum: 17125925 //备案号
    }
  },
  created() {
  }
}
</script>

<style>

#app {
  width: 100%;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s ease;
}

.fade-enter,
.fade-leave-active {
  opacity: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/myHeader.vue